import script from "./entries-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./entries-table.vue?vue&type=script&setup=true&lang=ts"

import "./entries-table.vue?vue&type=style&index=0&id=d0a39500&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0a39500"]])

export default __exports__